module.exports = __webpack_public_path__ + "static/media/Simon_Edvardsson.ff63179c.jpg";